import { Directive, ElementRef, OnInit, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({ selector: '[resized]' })
export class ElementResizeDirective implements OnInit {
  private elementReference: ElementRef<HTMLElement>;
  @Output() readonly resized = new EventEmitter<ResizedEvent>();

  public constructor(elementReference: ElementRef) {
    this.elementReference = elementReference;
  }

  public ngOnInit(): void {
    this.onElementResize();
  }

  @HostListener('window:resize')
  public onElementResize(): any {
    if (this.elementReference.nativeElement) {
      var w = this.elementReference.nativeElement.offsetWidth;
      var h = this.elementReference.nativeElement.offsetHeight;
      this.resized.emit(new ResizedEvent(w, h));
    }
  }
}

export class ResizedEvent {
  public constructor(width: number, height: number) {
    this.width = width;
    this.height = height;
  }

  public width: number;
  public height: number;
}
